'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _formReducer$plugin;

var _reduxForm = require('redux-form');

var _registerFormReducer = require('../../auth/modals/register/registerFormReducer');

var _registerFormReducer2 = _interopRequireDefault(_registerFormReducer);

var _loginFormReducer = require('../../auth/modals/login/loginFormReducer');

var _loginFormReducer2 = _interopRequireDefault(_loginFormReducer);

var _boardSharingFormReducer = require('../../workspace/header/utils/sharing/form/boardSharingFormReducer');

var _boardSharingFormReducer2 = _interopRequireDefault(_boardSharingFormReducer);

var _paymentFormReducer = require('../../user/account/payment/paymentFormReducer');

var _paymentFormReducer2 = _interopRequireDefault(_paymentFormReducer);

var _teamInputFormReducer = require('../../user/account/team/form/teamInputFormReducer');

var _teamInputFormReducer2 = _interopRequireDefault(_teamInputFormReducer);

var _registerFormConstants = require('../../auth/modals/register/registerFormConstants');

var _loginFormConstants = require('../../auth/modals/login/loginFormConstants');

var _boardSharingFormConstants = require('../../workspace/header/utils/sharing/form/boardSharingFormConstants');

var _paymentConstants = require('../../user/account/payment/paymentConstants');

var _teamFormConstants = require('../../user/account/team/form/teamFormConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib


// Reducers


// Constants


exports.default = _reduxForm.reducer.plugin((_formReducer$plugin = {}, _defineProperty(_formReducer$plugin, _registerFormConstants.REGISTER_FORM_NAME, _registerFormReducer2.default), _defineProperty(_formReducer$plugin, _loginFormConstants.LOGIN_FORM_NAME, _loginFormReducer2.default), _defineProperty(_formReducer$plugin, _paymentConstants.PAYMENT_FORM_NAME, _paymentFormReducer2.default), _defineProperty(_formReducer$plugin, _boardSharingFormConstants.ADD_SHARED_USER_FORM_NAME, _boardSharingFormReducer2.default), _defineProperty(_formReducer$plugin, _teamFormConstants.ADD_TEAM_MEMBER_FORM_NAME, _teamInputFormReducer2.default), _formReducer$plugin));


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/formReducer.js
// module id = 1779
// module chunks = 0